import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@common/helpers/translator';

import tournamentRulesIcon from '../../../../images/tournament-rules-icon.png';

const TournamentRules = ({ tournament }) => (
    <div className="tournament-stats tournament-rules">
        <div className="stats-top">
            <img src={tournamentRulesIcon} />
            <h2>{t('Rules')}</h2>
        </div>

        <div className="stats-content">
            <div className="stats-content-inner">
                {tournament.Description}
            </div>
        </div>
    </div>
);

TournamentRules.propTypes = {
    tournament: PropTypes.object.isRequired,
};

export default TournamentRules;